export default "__VITE_ASSET__DkPoS$cN__"